import statistic from './statistic'

export default {
  settings: {
    hasOvertime: true,
    hasShootouts: true,
    hasDelayedEvents: true,
    needToStopTimerOnPeriodDurationEnd: true
  },
  actionTypes: {
    numberOfPlayersChangeEvents: [
      'RED_CARD',
      'YELLOW_CARD',
      'PLAYER_ON_PITCH'
    ],
    score: [
      'GOAL',
      'DROP_GOAL',
      'DROP_GOAL_10_METERS_ATTACK',
      'DROP_GOAL_10_METERS_DEFENCE',
      'DROP_GOAL_20_METERS_ATTACK',
      'DROP_GOAL_20_METERS_DEFENCE',
      'DROP_GOAL_30_METERS_ATTACK',
      'DROP_GOAL_30_METERS_DEFENCE',
      'DROP_GOAL_40_METERS_ATTACK',
      'DROP_GOAL_40_METERS_DEFENCE',
      'DROP_GOAL_50_METERS_POSSESSION',
      'TRY',
      'PENALTY_TRY',
      'CONVERSION',
      'CONVERSION_GOAL'
    ]
  },
  modules: {
    info: [
      'timer',
      {
        type: 'players',
        props: {
          home: ingameData => ingameData.playersCount.home,
          away: ingameData => ingameData.playersCount.away
        }
      },
      {
        type: 'periods',
        props: {
          className: 'liveCardPeriods__slider_left'
        }
      }
    ],
    score: {
      component: 'score-component',
      score: ingameData => ingameData.score,
      tackles: ingameData => ingameData.tackles
    },
    fieldScheme: {
      component: 'rugby-field'
    },
    statistic,
    eventLog: true
  },
  storeScheme: {
    score: {
      home: 0,
      away: 0
    },
    tackles: {
      home: null,
      away: null
    },
    playersCount: {
      home: 15,
      away: 15
    },
    shootoutsLog: {
      home: [],
      away: []
    },
    getOvertimePeriodName: 'ОТ',
    shootoutPeriodName: 'P',
    shootoutStatisticTitle: 'trader.kicks.shootout.score',
    zone: 4,
    leftSideTeam: 1
  }
}
